import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EmailSmsLangModalComponent} from './email-sms-lang-modal.component';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import {DragDropModule} from "@angular/cdk/drag-drop";
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [EmailSmsLangModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertMessageModule,
    DragDropModule,
    ButtonModule
  ],
  exports: [EmailSmsLangModalComponent]
})
export class EmailSmsLangModalModule { }
